import Embed from './lib/Embed.jsx'
import CommentCount from './lib/CommentCount.jsx'

const HyvorTalk = {
  Embed,
  CommentCount
}

export default HyvorTalk
